export default {
  "content": "<g fill=\"none\"><path d=\"M0 0h9.474v9.474H0z\" fill=\"#f25022\"/><path d=\"M0 10.526h9.474V20H0z\" fill=\"#00a4ef\"/><path d=\"M10.526 0H20v9.474h-9.474z\" fill=\"#7fba00\"/><path d=\"M10.526 10.526H20V20h-9.474z\" fill=\"#ffb900\"/></g>",
  "attrs": {
    "height": "20",
    "viewBox": "0 0 20 20",
    "width": "20",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};